import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ProgressBar from './ProgressBar';
import { img } from '../../config';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  card: {
    width: 310,
    maxWidth: '100%',
    margin: 10,
    position: 'relative',
    paddingBottom: 40
  },
  media: {
    height: 140,
  },
  p: {
    fontSize: '0.8rem'
  },
  cardActions: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    justifyContent: 'flex-end',
  },
  notAvail: {
    color: '#aaa',
    fontFamily: 'Roboto',
    fontSize: '0.8rem',
    margin: 10
  }
}));

function CourseCard (props) {
  const classes = useStyles();
  const history = useHistory();
  const { course } = props;
  const imgSrc = img(course.img);

  const handleRunCourse = () => {
    history.push(`/kurs/${course.permalink}/cwiczenia`);
  }

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.media}
        image={imgSrc}
        title={course.title}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2" style={{ fontSize: '1.2rem' }}>
          {course.title}
        </Typography>
        <Typography component="p" className={classes.p}>
          {course.description}
        </Typography>
        <ProgressBar progress={course.progress} />
      </CardContent>
      <CardActions className={classes.cardActions}>
        {course.accessible && <Button size="small" color="primary" onClick={handleRunCourse}>Uruchom</Button>}
        {!course.accessible && <span className={classes.notAvail}>Niedostępny</span>}
      </CardActions>
    </Card>
  );
}

export default CourseCard;
